import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCashAccounts = () => import('./staff/cashAccounts')
const ViewStaffCashDetail = () => import('./staff/cashDetail')
const ViewStaffCheques = () => import('./staff/cheques')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'FinancesStaffDashboard',
  cashDetail: 'FinancesStaffCashDetail',
  cheques: 'FinancesStaffCheques',
  cashAccounts: 'FinancesStaffCashAccounts',
}

const router =
  [
    {
      path: '/st/finances',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Finanzas',
          }                
        },
        {
          path: 'cashDetail',
          name: VIEWS.cashDetail,
          component: ViewStaffCashDetail,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Movimientos de Caja/Banco',
          }                
        },     
        {
          path: 'cheques',
          name: VIEWS.cheques,
          component: ViewStaffCheques,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Cheques',
          }                
        },
        {
          path: 'cash-accounts',
          name: VIEWS.cashAccounts,
          component: ViewStaffCashAccounts,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Cajas y Cuentas',
          }                
        },
        // path anterior (favoritos, pestañas guardadas)
        {
          path: 'settings',
          redirect: { name: VIEWS.cashAccounts },
        },
      ]
    },

    {
      path: '/cu/finances',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/finances',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
